import Router from './Router';

function ManagerApp() {
  return (<Router/>);
}

export default ManagerApp;
